import angular from 'angular';
import template from './desktop-actions.html';
import desktopFrameMenuElement from '../../../elements/desktop-frame-menu/desktop-frame-menu';
class DesktopActionsController {
    $onInit() {
        this.menuItems = [
            {
                text: 'video-chat.actions.pin',
                icon: '#call-pin',
                isDisabled: () => false,
                isVisible: () => !this.isPinned,
                onClick: () => this.onTogglePin(),
            },
            {
                text: 'video-chat.actions.unpin',
                icon: '#call-pin',
                isDisabled: () => false,
                isVisible: () => this.isPinned,
                onClick: () => this.onTogglePin(),
            },
        ];
    }
}
const desktopActionsComponent = {
    template,
    bindings: {
        stream: '<',
        disabled: '<',
        onTogglePin: '&',
        isPinned: '<',
    },
    controller: DesktopActionsController,
};
export default angular
    .module('doxy.videoChat.callFrames.screenFrameDesktopActions', [
    desktopFrameMenuElement,
])
    .component('screenFrameDesktopActions', desktopActionsComponent).name;
